export default __webpack_public_path__ + "static/media/cel.0ba911ad.svg";